import { useGetCompanyDetailsQuery } from "web/features/company/companyApiSlice";
import { useFeatureIsOn } from "@growthbook/growthbook-react";

const useIsDashboardHeaderEnabled = () => {
  const { data: company, isLoading } = useGetCompanyDetailsQuery();
  const isDashboardHeaderEnabledCompany = company?.enableDashboardHeader;
  const isDashboardMenuEnabled = useFeatureIsOn("pwa_dashboard_menu");

  const isDashboardHeaderEnabled = isDashboardHeaderEnabledCompany && isDashboardMenuEnabled;

  return { isLoading, isDashboardHeaderEnabled };
};

export default useIsDashboardHeaderEnabled;
